// import { Fragment } from "react/jsx-runtime";
import { Box, Toolbar } from "@mui/material";
import { Outlet, useParams } from "react-router";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/de';
import { Title } from "./decoration/Title";
// import {  drawerWidth } from "./decoration/SideMenu";
// import SideMenu from "./decoration/SideMenu";
// import { styled } from '@mui/material/styles';
import * as React from "react";
import { useFetchTournamentQuery } from "../store/tournament/TournamentApi";
import { Link } from 'react-router-dom';



export default function Frame()
{

  // Ermitteln des aktuellen Jahres
  const {year} = useParams();

  // die aktuellen Turnierdaten immer schön cachen: 
  useFetchTournamentQuery(year);

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale="de"
    >
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh' 
      }}>
        <Title />
        <Box component="main" sx={{ flexGrow: 1, p: 3, pb: '3rem' }}>
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
      <Box component="footer" sx={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        py: 0.5, px: 2,
        backgroundColor: 'background.paper',
        borderTop: '1px solid', borderColor: 'divider',
        textAlign: 'right',
        zIndex: 1,
      }}>
        <Link
          to="/impressum" 
          style={{ 
            color: 'inherit', 
            opacity: 0.4, 
            fontSize: '0.75rem', 
            textDecoration: 'none' 
          }}>
          Impressum
        </Link>
      </Box>
    </LocalizationProvider>
  );

}


/*
Main arbeitet hier mit einem Verschiebemechanismus, der die Größe
des darzustellenden Bereichs dem geöffneten oder geschlossenem 
Seitenmenü anpasst. Hierdurch verändert sich nach dem Schließen
auch der Bereich, der die Darstellung ermöglicht. 
*/

/*
 * wird nicht mehr benötigt, da wir auch kein Side-Menü mehr haben
 
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingBottom: '2.5rem',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: 0,
        },
      },
    ],
  }),
);

 

export default function Frame()
{  

  // Ermitteln des aktuellen Jahres
  const {year} = useParams();

  // die aktuellen Turnierdaten immer schön cachen: 
  useFetchTournamentQuery(year);

  // Das Seitenmenü wird durch diesen Strang hier weiter berücksichtigt
  const [isSideMenuOpen, setSideMenuOpen] = React.useState(false);

  return(
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">  
      <div>
        
        <Box sx={{ display: 'flex' }}>         
          <Fragment>             
            <Title 
              isSideMenuOpen={isSideMenuOpen} 
              onSideMenuToggle={() => setSideMenuOpen(!isSideMenuOpen)} 
            />                   
          </Fragment>
          <SideMenu 
            // mittels 'key' erzwingen wir bei einem Jahreswechsel
            // auch das Neuladen des Frames...
            key={year}
            isSideMenuOpen={isSideMenuOpen} 
            onSideMenuToggle={() => setSideMenuOpen(!isSideMenuOpen)}
          />
          <Main open={isSideMenuOpen}>
            <Toolbar />
            <Outlet />
          </Main>          
        </Box>
      </div>
      <Box
        component="footer"
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          py: 0.5,
          px: 2,
          backgroundColor: 'background.paper',
          borderTop: '1px solid',
          borderColor: 'divider',
          textAlign: 'right',
          zIndex: (theme) => theme.zIndex.drawer - 1,
        }}
      >
        <Link
          to="/impressum"
          style={{ color: 'inherit', opacity: 0.4, fontSize: '0.75rem', textDecoration: 'none' }}
        >
          Impressum
        </Link>
      </Box>
    </LocalizationProvider>
  );
};

*/